import React, { lazy, ReactElement } from 'react';
import { RoutesPaths } from './RoutesPathsEnum';

const Instructions = lazy(async () => import('pages/Instructions/component'));
const TestDemoResult = lazy(
	async () => import('pages/TestDemoResult/component')
);
const TestPurchasedResult = lazy(
	async () => import('pages/TestPurchasedResult/component')
);
const RunningTest = lazy(async () => import('pages/RunningTest/component'));
const ProfileEdit = lazy(async () => import('pages/ProfileEdit/component'));
const ReportsPage = lazy(async () => import('pages/Reports/component'));
const AssessmentPlans = lazy(
	async () => import('pages/AssessmentPlans/component')
);
const ABAssessmentPlans = lazy(
	async () => import('pages/ABAssessmentPlans/component')
);
const Chat = lazy(async () => import('pages/Chat/component'));
const ChatDetails = lazy(async () => import('pages/ChatDetails/component'));
const VectorTest = lazy(async () => import('pages/VectorTest/component'));
const CoursesPage = lazy(async () => import('pages/Courses/component'));
const CourseDetails = lazy(async () => import('pages/CourseDetails/component'));

export const routes: RoutesModel[] = [
	{
		path: RoutesPaths.INSTRUCTIONS,
		element: <Instructions />
	},
	{
		path: RoutesPaths.RUNNING_TEST,
		element: <RunningTest />
	},
	{
		path: RoutesPaths.PROFILE_EDIT,
		element: <ProfileEdit />
	},
	{
		path: RoutesPaths.DEMO_REPORT,
		element: <TestDemoResult />
	},
	{
		path: RoutesPaths.PURCHASED_RESULT,
		element: <TestPurchasedResult />
	},
	{
		path: RoutesPaths.REPORTS,
		element: <ReportsPage />
	},
	{
		path: RoutesPaths.ASSESSMENT_PLANS,
		element: <AssessmentPlans />
	},
	{
		path: RoutesPaths.AB_ASSESSMENT_PLANS,
		element: <ABAssessmentPlans />
	},
	{
		path: RoutesPaths.CHAT,
		element: <Chat />
	},
	{
		path: RoutesPaths.CHAT_DETAILS,
		element: <ChatDetails />
	},
	{
		path: RoutesPaths.VECTOR_TEST,
		element: <VectorTest />
	},
	{
		path: RoutesPaths.COURSES,
		element: <CoursesPage />
	},
	{
		path: RoutesPaths.COURSES_DETAILS,
		element: <CourseDetails />
	}
];

export const getRoutes = (): RoutesModel[] => {
	return routes;
};

interface RoutesModel {
	path: string;
	element: ReactElement;
}
